import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

export const RemarkDialog = ({ open, onClose, onSubmit, initialRemark = '' }) => {
  const [remark, setRemark] = useState('');

  useEffect(() => {
    setRemark(initialRemark);
  }, [initialRemark, open]);

  const handleSubmit = () => {
    onSubmit(remark);
    setRemark('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ '& .MuiDialog-paper': { width: '600px', maxWidth: '80vw' } }}>
      <DialogTitle>Add Remark</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="remark"
          label="Remark"
          type="text"
          fullWidth
          variant="outlined"
          multiline
          rows={4}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} color="primary" disabled={!remark.trim()}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
